// extracted by mini-css-extract-plugin
export default {"cardInfo":"CardInfo_cardInfo__boCDG","valueDiv":"CardInfo_valueDiv__XzUsX","value":"CardInfo_value__Hf1mZ","isBold":"CardInfo_isBold__r6xg2"};